import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigProvider } from "../config/config";
import { AppDetectorProvider } from "../detector/detector";
import { SessionProvider } from "../session/session";
import { StorageProvider } from "../storage-service/storage-service";

@Injectable()
export class LidProvider {
    constructor(
        public http: HttpClient,
        public config: ConfigProvider,
        public AppDetector: AppDetectorProvider,
        public sessionProvider: SessionProvider,
        private storageService: StorageProvider
    ) { }

    getLid() {
        return new Promise<any>(async (resolve, reject) => {
            let isLoged = await this.checkInstantAuth();
            console.log(isLoged);
            if ((this.AppDetector.isLeaderBoardApp() || this.AppDetector.isSpooortsApp() || this.AppDetector.isTournamentApp()) && isLoged) {
                this.requestLidByToken().then((lid) => resolve(lid));
            } else if (!this.AppDetector.isEventsApp()) {
                resolve((await this.config.config).client.lid);
            } else {
                resolve(214601);
            }
        });
    }

    getClientLid() {
        return new Promise<any>(async (resolve, reject) => {
            resolve((await this.config.config).client.lid);
        });
    }

    getLidByToken() {
        return new Promise<any>(async (resolve, reject) => {
            let isLoged = await this.checkInstantAuth();
            console.log(isLoged);
            if (isLoged) {
                this.requestLidByToken().then((lid) => resolve(lid));
            } else {
                resolve((await this.config.config).client.lid);
            }
        });
    }

    checkInstantAuth() {
        return new Promise<any>((resolve, reject) => {
            this.storageService.getSaved("token", true).then((token) => {
                if (token) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    async requestLidByToken(): Promise<any> {
        let url = (await this.config.urlConfig()).ba2;
        return new Promise<any>((resolve, reject) => {
            this.sessionProvider.getToken(false, false).then((token) => {
                this.http
                    .get(url + `user/${token}/login-id`)
                    .toPromise()
                    .then((lid) => {
                        resolve(lid);
                    })
                    .catch((error) => {
                        reject();
                        console.log(
                            "error while requesting a lid from a server: " + error.message
                        );
                    });
            });
        });
    }
}



// WEBPACK FOOTER //
// /src/providers/lid-provider/lid-provider.ts